import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { authFetch } from "@/context/AuthContext";

const inputCls = "field mt-2";

export const ChangePasswordDialog = ({ open, onClose }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); setError(""); };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 10) return setError("New password must be at least 10 characters.");
    if (next !== confirm) return setError("New passwords do not match.");
    setBusy(true);
    try {
      await authFetch("/api/auth/change-password", { method: "POST", body: JSON.stringify({ current_password: current, new_password: next }) });
      toast.success("Password changed");
      reset();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { reset(); onClose(); } }}>
      <DialogContent data-testid="change-password-dialog" className="rounded-xl border-slate-200 bg-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold tracking-tight">Change Password</DialogTitle>
          <DialogDescription className="text-sm text-slate-600">Use at least 10 characters. You will stay signed in.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-ink" htmlFor="pw-current">Current Password</label>
            <input data-testid="pw-current-input" id="pw-current" type="password" required autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink" htmlFor="pw-new">New Password</label>
            <input data-testid="pw-new-input" id="pw-new" type="password" required autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink" htmlFor="pw-confirm">Confirm New Password</label>
            <input data-testid="pw-confirm-input" id="pw-confirm" type="password" required autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
          </div>
          {error && <p data-testid="pw-error" role="alert" className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>}
          <button type="submit" data-testid="pw-submit-button" disabled={busy} className="btn-primary w-full">
            {busy ? "Saving…" : "Update Password"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
